import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlan } from 'store/useBusinessToolStore/selectors';
import { useUserStore } from 'store/useUserStore';
import { getAuthUser } from 'store/useUserStore/selectors';

import { useAuthenticated } from './useAuthenticated';

export const useCheckIsDocShared = () => {
  const { isAuthenticated } = useAuthenticated();

  const userEmail = useUserStore(getAuthUser)?.email;
  const businessPlanCreatorEmail = useBusinessToolStore(getBusinessPlan)?.createdBy;

  const areEmailsEqual = userEmail === businessPlanCreatorEmail;

  return isAuthenticated && !areEmailsEqual;
};
